import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { userReducer } from './userReducer';
import { fileReducer } from './fileReducer';
import { errorReducer } from "./errorReducer";
import { listsReducer } from "./listsReducer";
import { partnershipsReducer } from './partnershipsReducer';
import { fileDetailsReducer } from './fileDetailsReducer';
import errorFilterReducer from './errorFilterReducer';
import { rowErrorsReducer } from './rowErrorsReducer';

const persistConfig = {
    key: 'root',
    storage: storageSession,
    whitelist: ['user', 'file', 'lists', 'error', 'fileDetails', 'partnerships', 'errorFilter', 'rowErrors'],
};

const appReducer = combineReducers({
    user: userReducer,
    file: fileReducer,
    error: errorReducer,
    lists: listsReducer,
    partnerships: partnershipsReducer,
    fileDetails: fileDetailsReducer,
    errorFilter: errorFilterReducer,
    rowErrors: rowErrorsReducer
});

const rootReducer = (state, action) => {
    if (action.type === 'RESET_APP') {
        storageSession.removeItem('persist:root');
        state = undefined;
    }
    return appReducer(state, action);
};

export default persistReducer(persistConfig, rootReducer);
